import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostServiceCallQuoteCalculateApplicationMarkupAndTotal } from 'src/app/models/quote/post-service-call-quote-calculate-application-markup-and-total';
import { PostServiceCallQuoteCalculateMarkupPageTotal } from 'src/app/models/quote/post-service-call-quote-calculate-markup-page-total';
import { PostServiceCallQuoteUpdateMarkupAndBidPrices } from 'src/app/models/quote/post-service-call-quote-update-markup-and-bid-prices';
import { QuoteStatusPayload } from 'src/app/models/quote/quote-status-payload';
import { ResponseCalculateMarkupPageTotal } from 'src/app/models/quote/response-calculate-markup-page-total';
import { ResponseDeclineQuote } from 'src/app/models/quote/response-decline-quote';
import { ResponseGetCustomerApprovalInfo } from 'src/app/models/quote/response-get-customer-approval-info';
import { ResponseGetValuesForMarkups } from 'src/app/models/quote/response-get-values-for-markups';
import { ResponseIsReadOnly } from 'src/app/models/quote/response-is-read-only';
import { ReturnPendingQuotePayload } from 'src/app/models/quote/return-pending-quote-payload';
import { ReturnServiceCallQuoteMarkupAndTotalForApplicationType } from 'src/app/models/quote/return-service-call-quote-markup-and-total-for-application-type';
import { PostEmail } from 'src/app/models/shared/post-email';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { PostUserId } from 'src/app/models/user/post-user-id';
import { ResponseSendEmail } from 'src/app/models/quote/response-send-email';
import { ResponseApproval } from 'src/app/models/quote/response-approval';
import { PostServieCallQuoteApprove } from 'src/app/models/quote/post-servie-call-quote-approve';
import { SearchResultQuotesPayload } from 'src/app/models/quote/search-result-quotes-payload';
import { PostServiceCallCreate } from 'src/app/models/quote/post-service-call-create';
import { ResponseCreateServiceCall } from 'src/app/models/quote/response-create-service-call';
import { PostAddToExistingServiceCall } from 'src/app/models/quote/post-add-to-existing-service-call';
import { ResponseAddToExistingServiceCall } from 'src/app/models/quote/response-add-to-existing-service-call';
import { PostServiceCallQuoteCreate } from 'src/app/models/quote/post-service-call-quote-create';
import { ResponseServiceCallQuoteAction } from 'src/app/models/quote/response-service-call-quote-action';
import { PostServiceCallQuoteUpdate } from 'src/app/models/quote/post-service-call-quote-update';
import { PostQuoteItemAssemblyCreate } from 'src/app/models/quote/post-quote-item-assembly-create';
import { ReturnQuoteQuestionsPayload } from 'src/app/models/quote/return-quote-questions-payload';
import { ReturnAttributeAnswer } from 'src/app/models/recommendation/return-attribute-answer';
import { ReturnServiceCallSetup } from 'src/app/models/quote/return-service-call-setup';
import { PostServiceCallQuoteItemAttributeAnswerUpdate } from 'src/app/models/quote/post-service-call-quote-item-attribute-answer-update';
import { PostQuoteQuestionsUpdate } from 'src/app/models/quote/post-quote-questions-update';
import { PostServiceCallQuoteItemsWithAttributesCreate } from 'src/app/models/quote/post-service-call-quote-items-with-attributes-create';
import { PostGetInventoryAttributes } from 'src/app/models/shared/post-get-inventory-attributes';
import { ResponseGetInventoryItemAttributesPayload } from 'src/app/models/quote/response-get-inventory-item-attributes-payload';
import { ReturnServiceCallQuote } from 'src/app/models/quote/return-service-call-quote';
import { ReturnQuoteHeader } from 'src/app/models/quote/return-quote-header';
import { PostRecommendationsForQuoteEditGet } from 'src/app/models/quote/post-recommendations-for-quote-edit-get';
import { ResponseGetRecommendationsForQuoteEdit } from 'src/app/models/quote/response-get-recommendations-for-quote-edit';
import { PostQuoteRecommendationUpate } from 'src/app/models/quote/post-quote-recommendation-upate';
import { ResponseUpdateQuoteRecommendations } from 'src/app/models/quote/response-update-quote-recommendations';
import { PostServiceCallQuoteItemSummaryGet } from 'src/app/models/quote/post-service-call-quote-item-summary-get';
import { ReturnItemsPayload } from 'src/app/models/recommendation/return-items-payload';
import { PostUpdateQuantities } from 'src/app/models/shared/post-update-quantities';
import { ReturnCalculateItemValues } from 'src/app/models/shared/return-calculate-item-values';
import { ResponseGetApplicationTypes } from 'src/app/models/shared/response-get-application-types';
import { PostServiceCallQuoteItemCreate } from 'src/app/models/quote/post-service-call-quote-item-create';
import { ReturnItem } from 'src/app/models/shared/return-item';
import { PostCalculateItemValues } from 'src/app/models/shared/post-calculate-item-values';
import { PostItemUpdate } from 'src/app/models/recommendation/post-item-update';
import { ResponseUpdateItem } from 'src/app/models/quote/response-update-item';
import { PostRecommendationItemSearch } from 'src/app/models/recommendation/post-recommendation-item-search';
import { SearchResultProductItemPayload } from 'src/app/models/shared/search-result-product-item-payload';
import { ApplicationTypeCategoryPayload } from 'src/app/models/shared/application-type-category-payload';
import { PostServiceCallQuoteTotalMarkupUpdateValues } from 'src/app/models/quote/post-service-call-quote-total-markup-update-values';
import { ResponseRecalculateMarkupsAndTotalsForQuote } from 'src/app/models/quote/response-recalculate-markups-and-totals-for-quote';
import { PostItemGetDetails } from 'src/app/models/shared/post-item-get-details';
import { ReturnSearchedRecommendationItemPayload } from 'src/app/models/recommendation/return-searched-recommendation-item-payload';
import { ResponseItemDetailsInAssemblyPayload } from 'src/app/models/shared/response-item-details-in-assembly-payload';
import { ReturnSearchedRecommendationItemsPayload } from 'src/app/models/recommendation/return-searched-recommendation-items-payload';
import { ResponseRegions } from 'src/app/models/shared/response-regions';
import { PostGetPayCodes } from 'src/app/models/shared/post-get-pay-codes';
import { ResponsePayCodes } from 'src/app/models/shared/response-pay-codes';
import { ResponseValidQuoteTemplate } from 'src/app/models/quote/response-valid-quote-template';
import { ResponseInfoQuoteEmailPreview } from 'src/app/models/quote/response-info-quote-email-preview';
import { ResponseGetFiles } from 'src/app/models/quote/response-get-files';
import { ResponseGetQuoteCopyHeader } from 'src/app/models/quote/response-get-quote-copy-header';
import { CopyServiceCallQuotePost } from 'src/app/models/quote/copy-service-call-quote-post';
import { CopyServiceCallQuoteResponse } from 'src/app/models/quote/copy-service-call-quote-response';
import { UtilityService } from '../utility.service';
import { UserDataService } from '../user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  private apis = {
    add: 'mfq_serviceCallQuote/Create/',
    update: 'mfq_serviceCallQuote/Update/',
    get: 'mfq_serviceCallQuote/Get/',
    getPendingQuotes: 'mfq_serviceCallQuote/GetPendingQuotes/',
    getHeaderDetails: 'mfq_serviceCallQuote/GetHeader/',
    getRecommendationsForQuoteEdit: 'mfq_serviceCallQuote/GetRecommendationsForQuoteEdit/',
    updateQuoteRecommendations: 'mfq_serviceCallQuote/UpdateQuoteRecommendations/',
    getItemsSummary: 'mfq_serviceCallQuote/GetItemsSummary/',
    getCustomerApprovalInfo: 'mfq_serviceCallQuote/GetCustomerApprovalInfo/',
    getQuoteQuestions: 'mfq_serviceCallQuote/GetQuoteQuestions/',
    getRecommendationIdsInQuote: 'mfq_serviceCallQuote/GetRecommendationIdsInQuote/',
    updateQuoteQuestions: 'mfq_serviceCallQuote/UpdateQuoteQuestions/',
    sendEmail: 'mfq_serviceCallQuote/SendEmail/',
    requestInternalApproval: 'mfq_serviceCallQuote/RequestInternalApproval/',
    internallyApprove: 'mfq_serviceCallQuote/InternallyApprove/',
    approveQuote: 'mfq_serviceCallQuote/ApproveQuote/',
    getValuesForMarkups: 'mfq_serviceCallQuote/GetValuesForMarkups/',
    calculateMarkupAndTotalForApplicationType: 'mfq_serviceCallQuote/CalculateMarkupAndBidPriceForApplicationType/',
    recalculateMarkupsAndTotalsForQuoteFromTotalMarkup: 'mfq_serviceCallQuote/RecalculateMarkupsAndTotalsForQuoteFromTotalMarkup/',
    recalculateMarkupsAndTotalsForQuoteFromTotalBidPrice: 'mfq_serviceCallQuote/RecalculateMarkupsAndTotalsForQuoteFromTotalBidPrice',
    updateMarkupAndBidPrices: 'mfq_serviceCallQuote/UpdateMarkupAndBidPrices/',
    declineQuote: 'mfq_serviceCallQuote/DeclineQuote/',
    calculateMarkupPageTotal: 'mfq_serviceCallQuote/CalculateMarkupPageTotal/',
    isReadOnly: 'mfq_serviceCallQuote/IsReadOnly/',
    downloadCsv: 'mfq_serviceCallQuote/GetQuoteCsv/',
    validQuoteTemplate: 'mfq_serviceCallQuote/QuoteTemplateIsValid/',
    validQuoteDocumentTemplate: 'mfq_serviceCallQuote/QuoteDocumentTemplateIsValid/',
    getFiles: 'mfq_serviceCallQuote/GetFiles/',
    getInfoForQuoteEmailPreview: 'mfq_serviceCallQuote/GetInfoForQuoteEmailPreview/',
    getQuoteCopyHeader: 'mfq_serviceCallQuote/GetQuoteCopyHeader/',
    copy: 'mfq_serviceCallQuote/Copy',
    getQuoteCSV: 'mfq_serviceCallQuote/GetQuoteCsv',
    previewQuoteDefaultPdf: 'mfq_serviceCallQuote/PreviewQuoteDefaultPdf',
    previewQuotePdf: 'mfq_serviceCallQuote/PreviewQuotePdf',
    previewQuoteDefaultDocx: 'mfq_serviceCallQuote/PreviewQuoteDefaultDocx',
    previewQuoteDocx: 'mfq_serviceCallQuote/PreviewQuoteDocx',

    updateQuantities: 'mfq_serviceCallQuoteItem/UpdateQuantities/',
    getItemTotals: 'mfq_serviceCallQuoteItem/GetItemTotals/',
    getItem: 'mfq_serviceCallQuoteItem/Get/',
    updateItem: 'mfq_serviceCallQuoteItem/Update/',
    deleteItem: 'mfq_serviceCallQuoteItem/Delete/',
    addItem: 'mfq_serviceCallQuoteItem/Create/',
    createItemsWithAttributes: 'mfq_serviceCallQuoteItem/CreateItemsWithAttributes/',
    getAttributes: 'mfq_serviceCallQuoteItem/GetAttributes/',
    addAssemblyItems: 'mfq_serviceCallQuoteItem/CreateAssemblyItems/',

    getApplicationTypes: 'utility/GetApplicationTypes/',
    autocompleteSalesPersonId: 'utility/AutocompleteSalesPersonId/',
    getPayCodes: 'utility/GetPayCodes/',
    autocompleteJobTitle: 'utility/AutocompleteJobTitle/',
    autocompleteQuoteTemplate: 'utility/AutocompleteQuoteTemplate/',
    autocompleteQuoteDocumentTemplate: 'utility/AutocompleteQuoteDocumentTemplate/',
    autocompleteQuoteUserDefinedStatuses: 'utility/AutocompleteQuoteUserDefinedStatus/',

    itemSearch: 'mfqAppItems/SearchForItems/',
    calculateItemValues: 'mfqAppItems/CalculateItemValues/',
    getItemItemDetails: 'mfqAppItems/GetItemItemDetails/',
    getCategoriesForApplicationType: 'mfqAppItems/GetCategoriesForApplicationType/',
    getInventoryItemAttributes: 'mfqAppItems/GetInventoryItemAttributes/',
    getSubItemsForAssemblyOption: 'mfqAppItems/GetSubItemsForAssemblyOption/',
    getItemDetailsInAssembly: 'mfqAppItems/GetItemDetailsInAssembly/',

    updateAttributes: 'mfq_serviceCallQuoteItemAttributeAnswer/Update/',

    getServiceCallSetupValues: 'mfqAppServiceCall/GetServiceCallSetupValues/',
    taskSearch: 'mfqAppServiceCall/AutocompleteTasks/',
    tasklistSearch: 'mfqAppServiceCall/AutocompleteTaskLists/',
    addServiceCall: 'mfqAppServiceCall/Create/',
    addToExistingServiceCall: 'mfqAppServiceCall/AddToExistingServiceCall/',
    autocompleteTechnicianId: 'mfqAppServiceCall/AutocompleteTechnician/',
    autocompleteServiceCall: 'mfqAppServiceCall/AutocompleteServiceCall/',
    autocompleteContractNumber: 'mfqAppServiceCall/AutocompleteContractNumber/',

    list: 'mfqAppAddress/GetQuotes/',
    getStatus: 'mfq_serviceCallQuoteStatus/Index/',
    getRegions: 'zmp_region/Index/',

  };

  constructor(
    private http: HttpClient,
    private utilityService: UtilityService,
    private userData: UserDataService
  ) { }

  autocompleteTechnicianId(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteTechnicianId, data);
  }

  autocompleteSalesPersonId(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteSalesPersonId, data);
  }

  calculateMarkupPageTotal(data: PostServiceCallQuoteCalculateMarkupPageTotal): Observable<ReturnMessage<ResponseCalculateMarkupPageTotal>> {
    return this.http.post<ReturnMessage<ResponseCalculateMarkupPageTotal>>(this.apis.calculateMarkupPageTotal, data);
  }

  calculateMarkupAndTotalForApplicationType(data: PostServiceCallQuoteCalculateApplicationMarkupAndTotal): Observable<ReturnMessage<ReturnServiceCallQuoteMarkupAndTotalForApplicationType>> {
    return this.http.post<ReturnMessage<ReturnServiceCallQuoteMarkupAndTotalForApplicationType>>(this.apis.calculateMarkupAndTotalForApplicationType, data);
  }

  updateMarkupAndBidPrices(data: PostServiceCallQuoteUpdateMarkupAndBidPrices): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateMarkupAndBidPrices, data);
  }

  isReadOnly(id: number): Observable<ReturnMessage<ResponseIsReadOnly>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseIsReadOnly>>(this.apis.isReadOnly, options);
  }

  declineQuote(id: number): Observable<ReturnMessage<ResponseDeclineQuote>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseDeclineQuote>>(this.apis.declineQuote, options);
  }

  getCustomerApprovalInfo(id: number): Observable<ReturnMessage<ResponseGetCustomerApprovalInfo>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseGetCustomerApprovalInfo>>(this.apis.getCustomerApprovalInfo, options);
  }

  getValuesForMarkups(id: number): Observable<ReturnMessage<ResponseGetValuesForMarkups>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseGetValuesForMarkups>>(this.apis.getValuesForMarkups, options);
  }

  sendEmail(id: number, data: PostEmail): Observable<ReturnMessage<ResponseSendEmail>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.post<ReturnMessage<ResponseSendEmail>>(this.apis.sendEmail, data, options);
  }

  requestInternalApproval(id: number): Observable<ReturnMessage<ResponseApproval>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseApproval>>(this.apis.requestInternalApproval, options);
  }

  internallyApprove(id: number): Observable<ReturnMessage<ResponseApproval>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseApproval>>(this.apis.internallyApprove, options);
  }

  approveQuote(data: PostServieCallQuoteApprove): Observable<ReturnMessage<ResponseApproval>> {
    return this.http.post<ReturnMessage<ResponseApproval>>(this.apis.approveQuote, data);
  }

  list(addressId: string, addressType: string): Observable<ReturnMessage<SearchResultQuotesPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', addressId)
        .set('type', addressType)
    };
    return this.http.get<ReturnMessage<SearchResultQuotesPayload>>(this.apis.list, options);
  }

  listFilter(addressId: string, addressType: string, filterData: PostFilterFields): Observable<ReturnMessage<SearchResultQuotesPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', addressId)
        .set('type', addressType)
    };
    return this.http.post<ReturnMessage<SearchResultQuotesPayload>>(this.apis.list, filterData, options);
  }

  addServiceCall(data: PostServiceCallCreate): Observable<ReturnMessage<ResponseCreateServiceCall>> {
    return this.http.post<ReturnMessage<ResponseCreateServiceCall>>(this.apis.addServiceCall, data);
  }

  addToExistingServiceCall(data: PostAddToExistingServiceCall): Observable<ReturnMessage<ResponseAddToExistingServiceCall>> {
    return this.http.post<ReturnMessage<ResponseAddToExistingServiceCall>>(this.apis.addToExistingServiceCall, data);
  }

  add(data: PostServiceCallQuoteCreate): Observable<ReturnMessage<ResponseServiceCallQuoteAction>> {
    return this.http.post<ReturnMessage<ResponseServiceCallQuoteAction>>(this.apis.add, data);
  }

  update(data: PostServiceCallQuoteUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.update, data);
  }

  deleteItem(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.delete<ReturnMessage<any>>(this.apis.deleteItem, options);
  }

  addAssemblyItems(data: PostQuoteItemAssemblyCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.addAssemblyItems, data);
  }

  getPendingQuotes(data: PostUserId): Observable<ReturnMessage<ReturnPendingQuotePayload>> {
    return this.http.post<ReturnMessage<ReturnPendingQuotePayload>>(this.apis.getPendingQuotes, data);
  }

  getQuoteQuestions(id: number): Observable<ReturnMessage<ReturnQuoteQuestionsPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnQuoteQuestionsPayload>>(this.apis.getQuoteQuestions, options);
  }

  getAttributes(id: number): Observable<ReturnMessage<ReturnAttributeAnswer[]>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnAttributeAnswer[]>>(this.apis.getAttributes, options);
  }

  getRecommendationIdsInQuote(id: number): Observable<ReturnMessage<number[]>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<number[]>>(this.apis.getRecommendationIdsInQuote, options);
  }

  getServiceCallSetupValues(id: number): Observable<ReturnMessage<ReturnServiceCallSetup>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnServiceCallSetup>>(this.apis.getServiceCallSetupValues, options);
  }

  updateAttributes(data: PostServiceCallQuoteItemAttributeAnswerUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateAttributes, data);
  }

  updateQuoteQuestions(data: PostQuoteQuestionsUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateQuoteQuestions, data);
  }

  createItemsWithAttributes(data: PostServiceCallQuoteItemsWithAttributesCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.createItemsWithAttributes, data);
  }

  getInventoryItemAttributes(data: PostGetInventoryAttributes): Observable<ReturnMessage<ResponseGetInventoryItemAttributesPayload>> {
    return this.http.post<ReturnMessage<ResponseGetInventoryItemAttributesPayload>>(this.apis.getInventoryItemAttributes, data);
  }

  getStatus(): Observable<ReturnMessage<QuoteStatusPayload>> {
    return this.http.get<ReturnMessage<QuoteStatusPayload>>(this.apis.getStatus);
  }

  get(id: number): Observable<ReturnMessage<ReturnServiceCallQuote>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnServiceCallQuote>>(this.apis.get, options);
  }

  getHeaderDetails(id: number): Observable<ReturnMessage<ReturnQuoteHeader>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnQuoteHeader>>(this.apis.getHeaderDetails, options);
  }

  getRecommendationsForQuoteEdit(data: PostRecommendationsForQuoteEditGet): Observable<ReturnMessage<ResponseGetRecommendationsForQuoteEdit>> {
    return this.http.post<ReturnMessage<ResponseGetRecommendationsForQuoteEdit>>(this.apis.getRecommendationsForQuoteEdit, data);
  }

  updateQuoteRecommendations(data: PostQuoteRecommendationUpate): Observable<ReturnMessage<ResponseUpdateQuoteRecommendations>> {
    return this.http.post<ReturnMessage<ResponseUpdateQuoteRecommendations>>(this.apis.updateQuoteRecommendations, data);
  }

  getItemsSummary(data: PostServiceCallQuoteItemSummaryGet): Observable<ReturnMessage<ReturnItemsPayload>> {
    return this.http.post<ReturnMessage<ReturnItemsPayload>>(this.apis.getItemsSummary, data);
  }

  updateQuantities(data: PostUpdateQuantities): Observable<ReturnMessage<ReturnCalculateItemValues>> {
    return this.http.post<ReturnMessage<ReturnCalculateItemValues>>(this.apis.updateQuantities, data);
  }

  getApplicationTypes(): Observable<ReturnMessage<ResponseGetApplicationTypes>> {
    return this.http.get<ReturnMessage<ResponseGetApplicationTypes>>(this.apis.getApplicationTypes);
  }

  addItem(data: PostServiceCallQuoteItemCreate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.addItem, data);
  }

  getItem(id: number): Observable<ReturnMessage<ReturnItem>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ReturnItem>>(this.apis.getItem, options);
  }

  calculateItemValues(data: PostCalculateItemValues): Observable<ReturnMessage<ReturnCalculateItemValues>> {
    return this.http.post<ReturnMessage<ReturnCalculateItemValues>>(this.apis.calculateItemValues, data);
  }

  updateItem(data: PostItemUpdate): Observable<ReturnMessage<ResponseUpdateItem>> {
    return this.http.post<ReturnMessage<ResponseUpdateItem>>(this.apis.updateItem, data);
  }

  itemSearch(data: PostRecommendationItemSearch): Observable<ReturnMessage<SearchResultProductItemPayload>> {
    return this.http.post<ReturnMessage<SearchResultProductItemPayload>>(this.apis.itemSearch, data);
  }

  getCategoriesForApplicationType(type: string): Observable<ReturnMessage<ApplicationTypeCategoryPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', type)
    };
    return this.http.get<ReturnMessage<ApplicationTypeCategoryPayload>>(this.apis.getCategoriesForApplicationType, options);
  }

  recalculateMarkupsAndTotalsForQuoteFromTotalMarkup(data: PostServiceCallQuoteTotalMarkupUpdateValues)
    : Observable<ReturnMessage<ResponseRecalculateMarkupsAndTotalsForQuote>> {
    return this.http.post<ReturnMessage<ResponseRecalculateMarkupsAndTotalsForQuote>>(this.apis.recalculateMarkupsAndTotalsForQuoteFromTotalMarkup, data);
  }

  recalculateMarkupsAndTotalsForQuoteFromTotalBidPrice(data: PostServiceCallQuoteTotalMarkupUpdateValues)
    : Observable<ReturnMessage<ResponseRecalculateMarkupsAndTotalsForQuote>> {
    return this.http.post<ReturnMessage<ResponseRecalculateMarkupsAndTotalsForQuote>>(this.apis.recalculateMarkupsAndTotalsForQuoteFromTotalBidPrice, data);
  }

  getItemItemDetails(id: string, type: string, offerType: string, offerId: string)
    : Observable<ReturnMessage<ReturnSearchedRecommendationItemPayload>> {
    const options = {
      params: new HttpParams()
        .set('type', type)
        .set('offerType', offerType)
        .set('offerId', offerId)
    };
    var sendObject = <PostItemGetDetails>{ id: id };
    return this.http.post<ReturnMessage<ReturnSearchedRecommendationItemPayload>>(this.apis.getItemItemDetails, sendObject, options);
  }

  getItemServiceLabourItemDetails(type: string, offerType: string, offerId: string, regionId: number, payCodeId: string, jobTitleId: string, jobTitleDescription: string)
    : Observable<ReturnMessage<ReturnSearchedRecommendationItemPayload>> {
    const options = {
      params: new HttpParams()
        .set('type', type)
        .set('offerType', offerType)
        .set('offerId', offerId)
    };
    var sendObject = <PostItemGetDetails>{
      jobTitleId: jobTitleId,
      jobTitleDescription: jobTitleDescription,
      regionId: regionId,
      payCodeId: payCodeId
    };
    return this.http.post<ReturnMessage<ReturnSearchedRecommendationItemPayload>>(this.apis.getItemItemDetails, sendObject, options);
  }

  getItemDetailsInAssembly(id: string, offerType: string, offerId: number, regionId: number)
    : Observable<ReturnMessage<ResponseItemDetailsInAssemblyPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('offerType', offerType)
        .set('offerId', offerId)
        .set('regionId', regionId)
    };
    return this.http.get<ReturnMessage<ResponseItemDetailsInAssemblyPayload>>(this.apis.getItemDetailsInAssembly, options);
  }

  getSubItemsForAssemblyOption(id: number, offerType: string, offerId: number, regionId: number)
    : Observable<ReturnMessage<ReturnSearchedRecommendationItemsPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('offerType', offerType)
        .set('offerId', offerId)
        .set('regionId', regionId)
    };
    return this.http.get<ReturnMessage<ReturnSearchedRecommendationItemsPayload>>(this.apis.getSubItemsForAssemblyOption, options);
  }

  taskSearch(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.taskSearch, data);
  }

  tasklistSearch(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.tasklistSearch, data);
  }

  downloadCsv(id: number): Observable<ReturnMessage<any>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<any>>(this.apis.downloadCsv, options);
  }

  getRegions(): Observable<ReturnMessage<ResponseRegions>> {
    return this.http.get<ReturnMessage<ResponseRegions>>(this.apis.getRegions);
  }

  getPayCodes(data: PostGetPayCodes): Observable<ReturnMessage<ResponsePayCodes>> {
    return this.http.post<ReturnMessage<ResponsePayCodes>>(this.apis.getPayCodes, data);
  }

  autocompleteJobTitle(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteJobTitle, data);
  }

  autocompleteServiceCall(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteServiceCall, data);
  }

  autocompleteQuoteTemplate(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteQuoteTemplate, data);
  }

  autocompleteQuoteDocumentTemplate(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteQuoteDocumentTemplate, data);
  }

  autocompleteContractNumber(data: PostFilterFields): Observable<ReturnMessage<string[]>> {
    return this.http.post<ReturnMessage<string[]>>(this.apis.autocompleteContractNumber, data);
  }

  validQuoteTemplate(data: PostFilterFields): Observable<ReturnMessage<ResponseValidQuoteTemplate>> {
    return this.http.post<ReturnMessage<ResponseValidQuoteTemplate>>(this.apis.validQuoteTemplate, data);
  }

  validQuoteDocumentTemplate(data: PostFilterFields): Observable<ReturnMessage<ResponseValidQuoteTemplate>> {
    return this.http.post<ReturnMessage<ResponseValidQuoteTemplate>>(this.apis.validQuoteDocumentTemplate, data);
  }

  getInfoForQuoteEmailPreview(id: number): Observable<ReturnMessage<ResponseInfoQuoteEmailPreview>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseInfoQuoteEmailPreview>>(this.apis.getInfoForQuoteEmailPreview, options);
  }

  getFiles(id: number): Observable<ReturnMessage<ResponseGetFiles>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
    };
    return this.http.get<ReturnMessage<ResponseGetFiles>>(this.apis.getFiles, options);
  }

  getQuoteCopyHeader(srcQuoteId: number, addressId: string, addressType: string): Observable<ReturnMessage<ResponseGetQuoteCopyHeader>> {
    const options = {
      params: new HttpParams()
        .set('srcQuoteId', srcQuoteId)
        .set('addressId', addressId)
        .set('addressType', addressType)
    };
    return this.http.get<ReturnMessage<ResponseGetQuoteCopyHeader>>(this.apis.getQuoteCopyHeader, options);
  }

  copy(data: CopyServiceCallQuotePost): Observable<ReturnMessage<CopyServiceCallQuoteResponse>> {
    return this.http.post<ReturnMessage<CopyServiceCallQuoteResponse>>(this.apis.copy, data);
  }

  getServiceLabourItemDetails(type: string, offerType: string, offerId: string, labourRateGroup: string, regionId: number, payCodeId: string, jobTitleId: string, jobTitleDescription: string)
    : Observable<ReturnMessage<ReturnSearchedRecommendationItemPayload>> {
    const options = {
      params: new HttpParams()
        .set('type', type)
        .set('offerType', offerType)
        .set('offerId', offerId)
    };
    var sendObject = <PostItemGetDetails>{
      labourRateGroup: labourRateGroup,
      jobTitleId: jobTitleId,
      jobTitleDescription: jobTitleDescription,
      regionId: regionId,
      payCodeId: payCodeId
    };
    return this.http.post<ReturnMessage<ReturnSearchedRecommendationItemPayload>>(this.apis.getItemItemDetails, sendObject, options);
  }

  getQuoteCSVDownloadURL(quoteId: number) {
    return `${this.apis.getQuoteCSV}/${quoteId}`;
  }

  getQuoteFileName(params: { extension: string, quoteId: number, quoteDescription: string }) {
    var editedQuoteDescription = "";
    if (params.quoteDescription !== null) {
      editedQuoteDescription = params.quoteDescription.replace(/[^a-z0-9]/gi, '_');
    }
    var fileName = `Service_Call_Quote_${params.quoteId}-${editedQuoteDescription}.${params.extension}`;
    return fileName;
  }

  downloadQuoteCSV(quoteId: number): Observable<Blob> {
    return this.http.get(`${this.apis.getQuoteCSV}/${quoteId}`, {
      responseType: 'blob'
    });
  }

  downloadPreviewQuoteDefaultPdf(params: { quoteId: number; userRequestId: number; quoteTemplateType: string; attachToServiceCall: boolean }): Observable<Blob> {
    var url = `${this.apis.previewQuoteDefaultPdf}/${params.quoteId}/${params.userRequestId}/${params.quoteTemplateType}?attachToServiceCall=${params.attachToServiceCall}`;
    return this.http.get(url, { responseType: 'blob'});
  }

  downloadPreviewQuotePdf(params: { quoteId: number; quoteTemplate: string; userRequestId: number; quoteTemplateType: string; attachToServiceCall: boolean }): Observable<Blob> {
    var url = `${this.apis.previewQuotePdf}/${params.quoteId}/${params.quoteTemplate}/${params.userRequestId}/${params.quoteTemplateType}?attachToServiceCall=${params.attachToServiceCall}`;
    return this.http.get(url, { responseType: 'blob'});
  }
 
  downloadPreviewQuoteDefaultDocx(params: { quoteId: number; userRequestId: number; quoteTemplateType: string; attachToServiceCall: boolean }): Observable<Blob> {
    var url = `${this.apis.previewQuoteDefaultDocx}/${params.quoteId}/${params.userRequestId}/${params.quoteTemplateType}?attachToServiceCall=${params.attachToServiceCall}`;
    return this.http.get(url, { responseType: 'blob'});
  }

  downloadPreviewQuoteDocx(params: { quoteId: number; quoteTemplate: string; userRequestId: number; quoteTemplateType: string; attachToServiceCall: boolean }): Observable<Blob> {
    var url = `${this.apis.previewQuoteDocx}/${params.quoteId}/${params.quoteTemplate}/${params.userRequestId}/${params.quoteTemplateType}?attachToServiceCall=${params.attachToServiceCall}`;
    return this.http.get(url, { responseType: 'blob'});
  }

  quoteCopyStates: any = {};
  setQuoteCopyState(srcQuoteId: number, state: { copyQuotePost: CopyServiceCallQuotePost; copyResponse: CopyServiceCallQuoteResponse; }) {
    this.quoteCopyStates[srcQuoteId] = state;
  }

  getQuoteCopyState(srcQuoteId: number): { copyQuotePost: CopyServiceCallQuotePost; copyResponse: CopyServiceCallQuoteResponse; } {
    return this.quoteCopyStates[srcQuoteId];
  }

  removeQuoteCopyState(srcQuoteId: number) {
    delete this.quoteCopyStates[srcQuoteId];
  }

  autocompleteQuoteUserDefinedStatuses(data: PostFilterFields): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.autocompleteQuoteUserDefinedStatuses, data);
  }
}
